
































































































































import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {TokensTableItem} from '@/model/resource/TokensTableItem'
import Tooltip from '@/components/tooltip/Tooltip.vue'
import TooltipMobileContent from '@/components/tooltip/TooltipMobileContent.vue'
import {$} from '@/facade'

@Component({
  components: {TooltipMobileContent, Tooltip},
})
export default class SwapTransactionDetailsCard extends MixinScreenSize {
  @Prop({type: TokensTableItem, required: true})
  tokenToReceive!: TokensTableItem
  @Prop({type: TokensTableItem, required: true})
  tokenToUse!: TokensTableItem
  @Prop({type: String, required: true})
  amountToUse!: string
  @Prop({type: String, required: true})
  amountToReceive!: string
  @Prop({type: String, required: true})
  minimumReceived!: string
  @Prop({type: String, required: true}) priceInverse!: string

  isPriceInverseSelected = true

  get priceTextDisplayed() {
    if (this.isPriceInverseSelected) {
      return $.translate('components.SwapTransactionDetailsCard.inversePrice')
    }

    return $.translate('components.SwapTransactionDetailsCard.price')
  }

  get priceValueDisplayed() {
    if (this.isPriceInverseSelected) {
      return $.translate('components.SwapTransactionDetailsCard.priceValue', {
        amount: this.priceInverse,
      })
    }

    return $.translate('components.SwapTransactionDetailsCard.priceValue', {
      amount: this.amountToUse,
    })
  }

  get priceRouteDisplayed() {
    if (this.isPriceInverseSelected) {
      return $.translate('components.SwapTransactionDetailsCard.priceToken', {
        tokenA: this.tokenToReceive.symbol,
        tokenB: this.tokenToUse.symbol,
      })
    }

    return $.translate('components.SwapTransactionDetailsCard.priceToken', {
      tokenA: this.tokenToUse.symbol,
      tokenB: this.tokenToReceive.symbol,
    })
  }

  handleClickSwapPrice() {
    this.isPriceInverseSelected = !this.isPriceInverseSelected
  }
}
